/**
 * PaymentMethodType Enum - Based on PaymentMethodType.java
 * Types of payment methods available
 */
export enum PaymentMethodType {
  CASH = 'CASH',
  TRANSFER = 'TRANSFER',
  CARD = 'CARD',
}

/**
 * Labels for payment method types in Spanish
 */
export const PAYMENT_METHOD_LABELS: Record<PaymentMethodType, string> = {
  [PaymentMethodType.CASH]: 'EFECTIVO',
  [PaymentMethodType.TRANSFER]: 'TRANSFERENCIA',
  [PaymentMethodType.CARD]: 'TARJETA',
};
